module.exports = "/_next/static/images/icon-vtour-4993f4578f9153cb376f9405b30bc268.png";